import { api } from '@packages/backend/convex/_generated/api';
import { useQuery } from 'convex-helpers/react';
import type React from 'react';

/**
 * Include Convex queries at root component, so they are not unmounted (and effectively cached).
 */
export const ConvexCachedQueries = ({ children }: { children: React.ReactNode }) => {
  // App-level queries should be put here, and should not depend on route params.
  const convexUserQuery = useQuery(api.auth.getCurrentUser);

  return children;
};
